const input = {
    username: 'Nome de usuário',
    password: 'Senha',
    email: 'E-mail',
    phone_number: 'Número de telefone',
    confirm_password: 'Confirme a senha',
    search_region_code: 'Pesquisar código de região',
    backup_code: 'Código de backup',
    code: 'Código',
    label_with_optional: '{{label}} (Opcional)',
    email_address: 'Endereço de e-mail',
    email_placeholder: 'Digite seu e-mail',
    enter_email: 'Digite o e-mail',
};
export default Object.freeze(input);
